export enum UserActionTypeEnum {
    SHOW_APP_ALERT = 'showAppAlert',
    SHOW_APP_MESSAGE = 'showAppMessage',
}
